import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { StripeRedirectProcessingService } from '@core/checkout/stripe-redirect-processing.service';
import { AuthService } from '@core/services/auth.service';
import { of, switchMap } from 'rxjs';

/**
 * Finishes a return from Stripe. Without a session there is nothing to finish
 * yet: the request used to go out unsigned, the interceptor read the answer as
 * an expired session and bounced to sign-in silently (QA audit #2, A18). Now the
 * redirect URL is remembered and the user comes back here after signing in.
 */
export const CheckoutGuard: CanActivateFn | CanActivateChildFn = (
  route,
  state
) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const redirect = inject(StripeRedirectProcessingService);

  return auth.isAuthenticated().pipe(
    switchMap((token) => {
      if (token) return redirect.onRedirect();

      sessionStorage.setItem('prev_rout', state.url);
      void router.navigate(['/sign-in'], { queryParams: route.queryParams });
      return of(false);
    })
  );
};
